import styled from '@emotion/styled';
import type { DataGridProps } from '@mui/x-data-grid';
import { DataGrid, gridClasses } from '@mui/x-data-grid';
import React from 'react';

export const ChargesEditDataGrid = styled((props: DataGridProps) => <DataGrid {...props} />)`
  background: #ffffff;
  border-radius: 8px;
  border-color: #0d1b271f;
  box-shadow:
    0px 1px 10px 0px rgba(13, 27, 39, 0.03),
    0px 1px 5px 0px rgba(13, 27, 39, 0.03),
    0px 2px 8px -1px rgba(13, 27, 39, 0.03);
  .${gridClasses.columnHeaders} {
    border: none;
  }
  /* MUI X v9 moved the header border from the .columnHeaders container onto each
     .columnHeader cell (via a higher-specificity .row--borderBottom rule); suppress it
     so it doesn't stack with the cell border-top below. */
  .${gridClasses.columnHeader} {
    border-bottom: none !important;
  }
  .${gridClasses.columnHeaderTitle} {
    color: #576063;
    font-weight: 400;
    font-size: 12px;
    padding-left: 4px;
    padding-right: 4px;
  }
  .${gridClasses.cell} {
    border-top: 1px solid #0d1b271f;
    border-bottom: none;
    padding-left: 16px;
    padding-right: 16px;
    /* v9 cells default to display:block; v6 flex-centered content. Restore centering. */
    display: flex;
    align-items: center;
    /* v9 sets line-height: <rowHeight> on cells for its block-cell text-centering.
       These cells are flex-centered instead, so reset line-height — otherwise the
       large value cascades into renderCell content (e.g. the Autocomplete wrapper
       in the Service name cell) and inflates its height, breaking centering. */
    line-height: normal;
  }
  .${gridClasses.cell}:focus-within,
    .${gridClasses.cell}:focus,
    .${gridClasses.columnHeader}:focus,
    .${gridClasses.columnHeader}:focus-within {
    outline: none;
  }
  .${gridClasses.virtualScroller}::-webkit-scrollbar {
    display: none;
  }
  .${gridClasses.columnSeparator} {
    display: none;
  }
`;
